(function () {
  const GIFT_SOURCE = 'gift-promotion';
  const LOG_PREFIX = '[gift-promotion]';
  let isApplying = false;
  let skipCartAddIntercept = false;
  let skipPostCartAddGiftApply = false;

  function isDebugEnabled() {
    if (window.GIFT_PROMOTION_DEBUG === false) return false;
    if (window.GIFT_PROMOTION_DEBUG === true) return true;
    try {
      if (window.localStorage?.getItem('gift_promotion_debug') === '1') return true;
      if (new URLSearchParams(window.location.search).has('gift_promotion_debug')) return true;
    } catch (error) {
      return false;
    }
    return false;
  }

  function log(...args) {
    if (!isDebugEnabled()) return;
    console.log(LOG_PREFIX, ...args);
  }

  function logWarn(...args) {
    if (!isDebugEnabled()) return;
    console.warn(LOG_PREFIX, ...args);
  }

  function logError(...args) {
    console.error(LOG_PREFIX, ...args);
  }

  function summarizeCartItem(item) {
    return {
      product_id: item.product_id,
      variant_id: item.variant_id,
      quantity: item.quantity,
      title: item.product_title || item.title,
      has_selling_plan: Boolean(item.selling_plan_allocation || item.selling_plan),
      properties: getLineItemProperties(item),
    };
  }

  function summarizeCart(cart) {
    return {
      item_count: cart.item_count,
      total_price: cart.total_price,
      items: (cart.items || []).map(summarizeCartItem),
    };
  }

  function idInList(id, list) {
    if (!list || list.length === 0) return false;
    return list.some((listId) => listId == id);
  }

  function normalizeProperties(properties) {
    if (!properties) return {};
    if (Array.isArray(properties)) {
      return properties.reduce((acc, entry) => {
        if (entry && entry.name != null) acc[entry.name] = entry.value;
        return acc;
      }, {});
    }
    return properties;
  }

  function getLineItemProperties(item) {
    return normalizeProperties(item.properties);
  }

  function hasSellingPlan(item) {
    return Boolean(item.selling_plan_allocation || item.selling_plan);
  }

  function hasRechargeBundleProperties(item) {
    const props = getLineItemProperties(item);
    return Boolean(props._rb_id || props._rc_bundle || props._rc_bundle_variant);
  }

  function matchesRequiredBundleProduct(item, promotion) {
    const requiredProductIds = promotion.requiredProductIds || [];
    const requiredProductVariantIds = promotion.requiredProductVariantIds || [];

    if (requiredProductIds.length === 0 && requiredProductVariantIds.length === 0) {
      return true;
    }

    if (idInList(item.product_id, requiredProductIds)) {
      return true;
    }

    const props = getLineItemProperties(item);

    if (props._rc_bundle) {
      const bundleParts = String(props._rc_bundle).split(':');
      const bundleParentId = bundleParts[bundleParts.length - 1];
      if (idInList(bundleParentId, requiredProductIds)) {
        return true;
      }
    }

    if (props._rc_bundle_variant && idInList(props._rc_bundle_variant, requiredProductVariantIds)) {
      return true;
    }

    if (props._rb_id && requiredProductIds.length > 0) {
      return true;
    }

    return false;
  }

  function isSubscriptionItemMatchingPromotion(item, promotion, promotionGifts) {
    if (isGiftItem(item, promotionGifts)) {
      return false;
    }

    if (!hasSellingPlan(item)) {
      return false;
    }

    const requiredProductIds = promotion.requiredProductIds || [];
    if (requiredProductIds.length === 0) {
      return true;
    }

    if (idInList(item.product_id, requiredProductIds)) {
      return true;
    }

    if (hasRechargeBundleProperties(item)) {
      return matchesRequiredBundleProduct(item, promotion);
    }

    return false;
  }

  function matchesGift(item, gift) {
    return gift.variantId == item.variant_id || gift.productId == item.product_id;
  }

  function isGiftItem(item, promotionGifts) {
    const props = getLineItemProperties(item);
    if (props._gift_promotion) return true;
    return promotionGifts.some((gift) => matchesGift(item, gift));
  }

  function giftKey(gift) {
    return String(gift.variantId != null ? gift.variantId : gift.productId);
  }

  function evaluateApplyGift(cart, promotion) {
    const promotionGifts = promotion.gifts;
    const itemsInCart = cart.items;
    const conditionType = promotion.conditionType;

    const nonGiftItems = itemsInCart.filter((item) => !isGiftItem(item, promotionGifts));

    let triggerConditionMet = false;

    if (conditionType === 'always_if_items') {
      if (nonGiftItems.length > 0) triggerConditionMet = true;
    } else if (
      conditionType === 'min_items' ||
      conditionType === 'min_price' ||
      conditionType === 'has_product'
    ) {
      triggerConditionMet = true;
    } else if (conditionType === 'exclude_products') {
      const excludedProductIds = promotion.excludedProductIds || [];
      const hasExcluded = nonGiftItems.some(
        (item) => excludedProductIds.indexOf(item.product_id) !== -1
      );
      if (!hasExcluded && nonGiftItems.length > 0) triggerConditionMet = true;
    } else if (conditionType === 'has_subscription') {
      triggerConditionMet = itemsInCart.some((item) =>
        isSubscriptionItemMatchingPromotion(item, promotion, promotionGifts)
      );

      if (!triggerConditionMet && promotion.requiredProductIds?.length) {
        const subscriptionItems = itemsInCart.filter(
          (item) => hasSellingPlan(item) && !isGiftItem(item, promotionGifts)
        );
        const subscriptionQuantity = subscriptionItems.reduce(
          (sum, item) => sum + item.quantity,
          0
        );
        if (subscriptionItems.length > 0 && subscriptionQuantity >= 12) {
          triggerConditionMet = true;
        }
      }
    }

    let applyGift = triggerConditionMet;

    if (applyGift && promotion.minPriceValue !== null) {
      const totalNonGiftPrice = itemsInCart.reduce((acc, item) => {
        return isGiftItem(item, promotionGifts) ? acc : acc + item.final_line_price;
      }, 0);
      const minPriceInCents = parseFloat(promotion.minPriceValue) * 100;
      if (totalNonGiftPrice < minPriceInCents) applyGift = false;
    }

    if (applyGift && promotion.minItemsValue !== null) {
      const totalNonGiftQuantity = itemsInCart.reduce((acc, item) => {
        return isGiftItem(item, promotionGifts) ? acc : acc + item.quantity;
      }, 0);
      if (totalNonGiftQuantity < promotion.minItemsValue) applyGift = false;
    }

    if (applyGift && conditionType !== 'has_subscription') {
      const requiredProductIds = promotion.requiredProductIds || [];
      if (requiredProductIds.length > 0) {
        const hasRequiredProduct = itemsInCart.some(
          (item) => requiredProductIds.indexOf(item.product_id) !== -1
        );
        if (!hasRequiredProduct) applyGift = false;
      }
    }

    log('evaluateApplyGift', {
      conditionType,
      triggerConditionMet,
      applyGift,
      cart: summarizeCart(cart),
      promotion: {
        gifts: promotion.gifts,
        requiredProductIds: promotion.requiredProductIds,
        requiredProductVariantIds: promotion.requiredProductVariantIds,
      },
    });

    return applyGift;
  }

  function requestItemQualifiesForBundleGift(item, promotion) {
    if (promotion.conditionType !== 'has_subscription') return false;
    if (!item.selling_plan) return false;

    const props = normalizeProperties(item.properties);
    const requiredProductIds = promotion.requiredProductIds || [];
    const requiredProductVariantIds = promotion.requiredProductVariantIds || [];

    if (requiredProductIds.length === 0 && requiredProductVariantIds.length === 0) {
      return true;
    }

    if (item.id && idInList(item.id, requiredProductVariantIds)) {
      return true;
    }

    if (props._rc_bundle) {
      const bundleParts = String(props._rc_bundle).split(':');
      const bundleParentId = bundleParts[bundleParts.length - 1];
      if (idInList(bundleParentId, requiredProductIds)) return true;
    }

    if (props._rc_bundle_variant && idInList(props._rc_bundle_variant, requiredProductVariantIds)) {
      return true;
    }

    if (props._rb_id && requiredProductIds.length > 0) {
      return true;
    }

    return false;
  }

  function tryInjectGiftsIntoAddRequest(body) {
    const promotion = window.activeGiftPromotion;
    if (!promotion?.gifts?.length || typeof body !== 'string') {
      return { body, injected: false };
    }

    let data;
    try {
      data = JSON.parse(body);
    } catch (error) {
      return { body, injected: false };
    }

    const requestItems = Array.isArray(data.items) ? data.items : data.id ? [data] : [];
    if (requestItems.length === 0) return { body, injected: false };

    const shouldInject = requestItems.some((item) => requestItemQualifiesForBundleGift(item, promotion));
    if (!shouldInject) {
      log('tryInjectGiftsIntoAddRequest: skipped (request does not qualify)', {
        requestItemsCount: requestItems.length,
      });
      return { body, injected: false };
    }

    if (Array.isArray(data.items)) {
      let injected = false;
      for (const gift of promotion.gifts) {
        if (gift.variantId == null) {
          logWarn('tryInjectGiftsIntoAddRequest: gift has no available variant, skipping', gift);
          continue;
        }
        const exists = data.items.some((item) => item.id == gift.variantId);
        if (!exists) {
          data.items.push({
            id: gift.variantId,
            quantity: 1,
            properties: { _gift_promotion: 'true' },
          });
          injected = true;
          log('tryInjectGiftsIntoAddRequest: injected gift variant', gift.variantId);
        }
      }
      if (injected) {
        skipPostCartAddGiftApply = true;
        log('tryInjectGiftsIntoAddRequest: modified cart/add payload', {
          itemsCount: data.items.length,
          giftVariantIds: promotion.gifts.map((gift) => gift.variantId),
        });
        return { body: JSON.stringify(data), injected: true };
      }
    }

    return { body, injected: false };
  }

  function getGiftQuantityInCart(cart, promotionGifts) {
    return cart.items.reduce((total, item) => {
      return isGiftItem(item, promotionGifts) ? total + item.quantity : total;
    }, 0);
  }

  function hasNonGiftItems(cart, promotionGifts) {
    return cart.items.some((item) => !isGiftItem(item, promotionGifts));
  }

  function getGiftLineEntries(cart, promotionGifts) {
    return cart.items
      .map((item, index) => ({
        item,
        line: item.index != null ? item.index + 1 : index + 1,
      }))
      .filter(({ item }) => isGiftItem(item, promotionGifts));
  }

  function getMissingGifts(cart, promotionGifts) {
    return promotionGifts.filter(
      (gift) => !cart.items.some((item) => matchesGift(item, gift))
    );
  }

  function giftsAreCorrectlyInCart(cart, promotion) {
    const promotionGifts = promotion.gifts;
    const giftLines = getGiftLineEntries(cart, promotionGifts);

    if (giftLines.length !== promotionGifts.length) return false;
    if (giftLines.some(({ item }) => item.quantity !== 1)) return false;

    return getMissingGifts(cart, promotionGifts).length === 0;
  }

  function getGiftLineNumbers(cart, promotionGifts) {
    return getGiftLineEntries(cart, promotionGifts).map(({ line }) => line);
  }

  async function fetchCart() {
    const cartUrl = window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js';
    const cartResponse = await fetch(cartUrl, { cache: 'no-store' });
    return cartResponse.json();
  }

  function isCartAddRequest(input) {
    const url = typeof input === 'string' ? input : input?.url || '';
    return url.includes('/cart/add');
  }

  function isCheckoutNavigation(url) {
    if (!url) return false;
    const urlString = String(url);
    return urlString.includes('/checkout') || urlString.includes('shop.app/checkout');
  }

  function getCheckoutUrl() {
    if (window.routes?.cart_url) {
      const cartUrl = new URL(window.routes.cart_url, window.location.origin);
      return `${cartUrl.origin}/checkout`;
    }
    return '/checkout';
  }

  async function applyGiftBeforeNavigation(navigate) {
    log('applyGiftBeforeNavigation: start');
    if (!window.activeGiftPromotion) {
      logWarn('applyGiftBeforeNavigation: no active promotion, navigating without gift');
      navigate();
      return;
    }

    try {
      await applyGiftCartWithRetry(8, 200);
    } catch (error) {
      logError('applyGiftBeforeNavigation: error', error);
    }

    navigate();
  }

  async function applyGiftCartWithRetry(maxAttempts, delayMs) {
    log('applyGiftCartWithRetry: start', { maxAttempts, delayMs });
    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      log('applyGiftCartWithRetry: attempt', attempt + 1, '/', maxAttempts);
      await applyGiftCart();

      const promotion = window.activeGiftPromotion;
      if (!promotion) {
        logWarn('applyGiftCartWithRetry: promotion removed during retry');
        return;
      }

      const cart = await fetchCart();
      const shouldApply = evaluateApplyGift(cart, promotion);
      const giftsPresent = giftsAreCorrectlyInCart(cart, promotion);
      log('applyGiftCartWithRetry: attempt result', {
        attempt: attempt + 1,
        shouldApply,
        giftsPresent,
      });

      if (shouldApply && giftsPresent) {
        log('applyGiftCartWithRetry: success');
        return;
      }

      if (attempt < maxAttempts - 1) {
        await new Promise((resolve) => setTimeout(resolve, delayMs));
      }
    }
    logWarn('applyGiftCartWithRetry: exhausted attempts without gift in cart');
  }

  async function handleRechargeCheckout(existingCallback) {
    log('handleRechargeCheckout: Recharge onAddToCart fired', {
      hasExistingCallback: typeof existingCallback === 'function',
    });
    await applyGiftCartWithRetry(10, 200);

    if (typeof existingCallback === 'function') {
      log('handleRechargeCheckout: delegating to existing Recharge callback');
      return existingCallback.apply(this, arguments);
    }

    const checkoutUrl = getCheckoutUrl();
    log('handleRechargeCheckout: redirecting to checkout', checkoutUrl);
    window.location.href = checkoutUrl;
  }

  function hookLocationHref() {
    try {
      const hrefDescriptor = Object.getOwnPropertyDescriptor(window.Location.prototype, 'href');
      if (!hrefDescriptor?.set || hrefDescriptor.set.__giftPromotionPatched) return;

      const originalHrefSet = hrefDescriptor.set;
      const patchedHrefSet = function patchedHrefSet(url) {
        if (isCheckoutNavigation(url) && window.activeGiftPromotion) {
          log('location.href intercept: checkout navigation', url);
          applyGiftBeforeNavigation(() => originalHrefSet.call(window.location, url));
          return;
        }
        return originalHrefSet.call(window.location, url);
      };
      patchedHrefSet.__giftPromotionPatched = true;

      Object.defineProperty(window.Location.prototype, 'href', {
        ...hrefDescriptor,
        set: patchedHrefSet,
      });
    } catch (error) {
      logWarn('hookLocationHref: unable to patch location.href', error);
    }
  }

  function initRechargeHooks() {
    if (window.__giftPromotionHooksInstalled) return;
    window.__giftPromotionHooksInstalled = true;
    log('initRechargeHooks: installed fetch, XHR, location hooks');

    const originalFetch = window.fetch.bind(window);
    window.fetch = async function giftPromotionFetch(input, init) {
      let requestInit = init;
      const url = typeof input === 'string' ? input : input?.url || '';

      if (
        !skipCartAddIntercept &&
        window.activeGiftPromotion &&
        isCartAddRequest(input) &&
        init?.body
      ) {
        log('fetch intercept: cart/add request', { url, skipCartAddIntercept });
        const injectionResult = tryInjectGiftsIntoAddRequest(init.body);
        if (injectionResult.injected) {
          requestInit = { ...init, body: injectionResult.body };
        }
      }

      const response = await originalFetch(input, requestInit);

      if (
        skipCartAddIntercept ||
        !window.activeGiftPromotion ||
        !isCartAddRequest(input) ||
        !response.ok
      ) {
        if (isCartAddRequest(input)) {
          log('fetch intercept: cart/add response ignored', {
            url,
            skipCartAddIntercept,
            hasPromotion: Boolean(window.activeGiftPromotion),
            ok: response.ok,
            status: response.status,
          });
        }
        return response;
      }

      if (skipPostCartAddGiftApply) {
        log('fetch intercept: skipping post-add apply (gift injected in request)');
        skipPostCartAddGiftApply = false;
        return response;
      }

      log('fetch intercept: cart/add success, applying gift', { url, status: response.status });
      try {
        await applyGiftCartWithRetry(6, 150);
      } catch (error) {
        logError('fetch intercept: cart/add hook error', error);
      }

      return response;
    };

    const originalXhrOpen = XMLHttpRequest.prototype.open;
    const originalXhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function giftPromotionXhrOpen(method, url, ...rest) {
      this._giftPromotionUrl = url;
      return originalXhrOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function giftPromotionXhrSend(body) {
      let requestBody = body;

      if (
        !skipCartAddIntercept &&
        window.activeGiftPromotion &&
        this._giftPromotionUrl?.includes('/cart/add') &&
        typeof requestBody === 'string'
      ) {
        log('XHR intercept: cart/add request', { url: this._giftPromotionUrl });
        const injectionResult = tryInjectGiftsIntoAddRequest(requestBody);
        if (injectionResult.injected) {
          requestBody = injectionResult.body;
          this._giftPromotionInjected = true;
        }
      }

      this.addEventListener('load', function giftPromotionXhrLoad() {
        if (
          skipCartAddIntercept ||
          !window.activeGiftPromotion ||
          !this._giftPromotionUrl?.includes('/cart/add') ||
          this.status < 200 ||
          this.status >= 300
        ) {
          if (this._giftPromotionUrl?.includes('/cart/add')) {
            log('XHR intercept: cart/add response ignored', {
              url: this._giftPromotionUrl,
              status: this.status,
              skipCartAddIntercept,
              hasPromotion: Boolean(window.activeGiftPromotion),
            });
          }
          return;
        }

        if (this._giftPromotionInjected || skipPostCartAddGiftApply) {
          log('XHR intercept: skipping post-add apply (gift injected in request)', {
            url: this._giftPromotionUrl,
          });
          this._giftPromotionInjected = false;
          skipPostCartAddGiftApply = false;
          return;
        }

        log('XHR intercept: cart/add success, applying gift', {
          url: this._giftPromotionUrl,
          status: this.status,
        });
        applyGiftCartWithRetry(6, 150).catch((error) => {
          logError('XHR intercept: cart/add hook error', error);
        });
      });

      return originalXhrSend.call(this, requestBody);
    };

    const originalAssign = window.location.assign.bind(window.location);
    window.location.assign = function giftPromotionAssign(url) {
      if (isCheckoutNavigation(url)) {
        log('location.assign intercept: checkout navigation', url);
        applyGiftBeforeNavigation(() => originalAssign(url));
        return;
      }
      originalAssign(url);
    };

    const originalReplace = window.location.replace.bind(window.location);
    window.location.replace = function giftPromotionReplace(url) {
      if (isCheckoutNavigation(url)) {
        log('location.replace intercept: checkout navigation', url);
        applyGiftBeforeNavigation(() => originalReplace(url));
        return;
      }
      originalReplace(url);
    };

    hookLocationHref();
  }

  async function cartAdd(variantId) {
    skipCartAddIntercept = true;
    log('cartAdd: adding gift variant', variantId);
    try {
      const response = await fetch(window.routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: { _gift_promotion: 'true' },
        }),
      });
      if (!response.ok) {
        const errorBody = await response.text();
        logError('cartAdd: failed', { variantId, status: response.status, errorBody });
        throw new Error('Failed to add gift to cart');
      }
      log('cartAdd: success', variantId);
    } finally {
      skipCartAddIntercept = false;
    }
  }

  async function cartChangeLine(line, quantity) {
    const response = await fetch(window.routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify({ line, quantity }),
    });

    if (!response.ok) {
      const errorBody = await response.text();
      logError('cartChangeLine: failed', { line, quantity, status: response.status, errorBody });
      throw new Error('Failed to update cart line');
    }

    return response.json();
  }

  async function removeGiftItemsFromCart(cart, promotionGifts) {
    const giftLines = getGiftLineNumbers(cart, promotionGifts).sort((a, b) => b - a);
    log('removeGiftItemsFromCart: removing gift lines', giftLines);

    for (const line of giftLines) {
      await cartChangeLine(line, 0);
    }
  }

  async function normalizeGiftQuantities(cart, promotionGifts) {
    const giftLines = getGiftLineEntries(cart, promotionGifts);
    if (giftLines.length === 0) return false;

    const seenGifts = new Set();
    const pendingChanges = [];

    for (const { item, line } of giftLines) {
      const gift = promotionGifts.find((candidate) => matchesGift(item, candidate));

      if (!gift || seenGifts.has(giftKey(gift))) {
        pendingChanges.push({ line, quantity: 0 });
        continue;
      }

      seenGifts.add(giftKey(gift));
      if (item.quantity !== 1) {
        pendingChanges.push({ line, quantity: 1 });
      }
    }

    if (pendingChanges.length === 0) return false;

    logWarn('normalizeGiftQuantities: fixing gift lines', {
      pendingChanges,
      giftLines: giftLines.map(({ line, item }) => ({ line, quantity: item.quantity })),
    });

    // Descending order: removing a line shifts the line numbers after it.
    pendingChanges.sort((a, b) => b.line - a.line);

    for (const { line, quantity } of pendingChanges) {
      await cartChangeLine(line, quantity);
    }

    return true;
  }

  async function refreshCartIconBubble() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    const response = await fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = doc.querySelector('.shopify-section');
    if (source) bubble.innerHTML = source.innerHTML;
  }

  async function refreshCartDrawer() {
    const response = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const targetInner = document.querySelector('#CartDrawer .drawer__inner');
    const sourceInner = doc.querySelector('#CartDrawer .drawer__inner');

    if (targetInner && sourceInner) {
      targetInner.innerHTML = sourceInner.innerHTML;
    }

    const drawer = document.querySelector('cart-drawer');
    const sourceDrawer = doc.querySelector('cart-drawer');
    if (drawer && sourceDrawer) {
      drawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
    } else if (drawer) {
      drawer.classList.toggle(
        'is-empty',
        doc.querySelector('cart-drawer-items')?.classList.contains('is-empty') ?? false
      );
    }
  }

  async function refreshMainCartPage() {
    const mainCartItems = document.getElementById('main-cart-items');
    if (!mainCartItems) return;

    const sectionId = mainCartItems.dataset.id;
    if (!sectionId) return;

    const response = await fetch(`${window.routes.cart_url}?section_id=main-cart-items`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = doc.querySelector('cart-items');
    const target = document.querySelector('cart-items');
    if (source && target) target.innerHTML = source.innerHTML;

    const footer = document.getElementById('main-cart-footer');
    if (footer) {
      const footerResponse = await fetch(`${window.routes.cart_url}?section_id=main-cart-footer`);
      const footerHtml = await footerResponse.text();
      const footerDoc = new DOMParser().parseFromString(footerHtml, 'text/html');
      const footerSource = footerDoc.querySelector('.js-contents');
      const footerTarget = footer.querySelector('.js-contents');
      if (footerSource && footerTarget) footerTarget.innerHTML = footerSource.innerHTML;
    }
  }

  async function refreshCartSections() {
    if (document.querySelector('cart-drawer-items')) {
      await refreshCartDrawer();
    }
    if (document.querySelector('cart-items')) {
      await refreshMainCartPage();
    }
    await refreshCartIconBubble();
  }

  async function applyGiftCart() {
    const promotion = window.activeGiftPromotion;
    if (!promotion || !promotion.gifts || promotion.gifts.length === 0) {
      log('applyGiftCart: skipped (no active promotion)');
      return;
    }
    if (isApplying) {
      log('applyGiftCart: skipped (already applying)');
      return;
    }

    isApplying = true;
    log('applyGiftCart: start');

    try {
      const cart = await fetchCart();
      const promotionGifts = promotion.gifts;
      const applyGift = evaluateApplyGift(cart, promotion);

      let cartChanged = false;

      if (applyGift) {
        log('applyGiftCart: should apply gift');

        let currentCart = cart;
        const normalized = await normalizeGiftQuantities(currentCart, promotionGifts);
        if (normalized) {
          cartChanged = true;
          currentCart = await fetchCart();
        }

        const missingGifts = getMissingGifts(currentCart, promotionGifts);
        log('applyGiftCart: missing gifts', missingGifts);

        for (const gift of missingGifts) {
          if (gift.variantId == null) {
            logWarn('applyGiftCart: gift has no available variant, skipping', gift);
            continue;
          }
          try {
            await cartAdd(gift.variantId);
            cartChanged = true;
          } catch (error) {
            logError('applyGiftCart: unable to add gift, continuing with the rest', {
              gift,
              error,
            });
          }
        }
      } else if (!hasNonGiftItems(cart, promotionGifts)) {
        log('applyGiftCart: cart only has gift items, removing gifts');
        const giftQuantity = getGiftQuantityInCart(cart, promotionGifts);
        if (giftQuantity > 0) {
          await removeGiftItemsFromCart(cart, promotionGifts);
          cartChanged = true;
        }
      } else {
        log('applyGiftCart: should remove gift (conditions not met)');
        const giftQuantity = getGiftQuantityInCart(cart, promotionGifts);
        if (giftQuantity > 0) {
          await removeGiftItemsFromCart(cart, promotionGifts);
          cartChanged = true;
        }
      }

      if (cartChanged) {
        const updatedCart = await fetchCart();
        log('applyGiftCart: cart updated', summarizeCart(updatedCart));
        await refreshCartSections();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: GIFT_SOURCE,
            cartData: updatedCart,
          });
        }
      } else {
        log('applyGiftCart: no cart changes needed');
      }
    } catch (error) {
      logError('applyGiftCart: error', error);
    } finally {
      isApplying = false;
    }
  }

  function wrapRechargeOnAddToCart() {
    window.RechargeBundle = window.RechargeBundle || {};
    if (window.RechargeBundle.onAddToCart?.__giftPromotionWrapped) return;

    const existingRechargeOnAddToCart = window.RechargeBundle.onAddToCart;
    const giftPromotionRechargeOnAddToCart = function giftPromotionRechargeOnAddToCart() {
      return handleRechargeCheckout(existingRechargeOnAddToCart);
    };
    giftPromotionRechargeOnAddToCart.__giftPromotionWrapped = true;
    window.RechargeBundle.onAddToCart = giftPromotionRechargeOnAddToCart;
    log('wrapRechargeOnAddToCart: wrapped RechargeBundle.onAddToCart', {
      hadExistingCallback: typeof existingRechargeOnAddToCart === 'function',
    });
  }

  function initGiftPromotion() {
    log('initGiftPromotion: start', {
      debugEnabled: isDebugEnabled(),
      activeGiftPromotion: window.activeGiftPromotion,
      rechargeBundleWrapped: Boolean(window.RechargeBundle?.onAddToCart?.__giftPromotionWrapped),
    });

    window.__giftPromotionHandleRechargeCheckout = handleRechargeCheckout;

    wrapRechargeOnAddToCart();
    [250, 1000, 2500, 5000].forEach((delay) => {
      window.setTimeout(wrapRechargeOnAddToCart, delay);
    });

    initRechargeHooks();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === GIFT_SOURCE) return;
        log('cartUpdate event received', { source: event?.source });
        applyGiftCart();
      });
    } else {
      logWarn('initGiftPromotion: pub/sub not available');
    }

    window.addEventListener('pageshow', () => {
      log('pageshow: re-running applyGiftCart');
      applyGiftCart();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyGiftCart);
    } else {
      applyGiftCart();
    }

    log(
      'initGiftPromotion: ready. Enable logs with window.GIFT_PROMOTION_DEBUG = true or ?gift_promotion_debug=1'
    );
  }

  initGiftPromotion();
})();
